import Problem from "features/cases/blocks/Problem";
import React, { useState } from "react";
import { useParams } from "react-router-dom";

import PageLayout from "../../common/PageLayout";

function getProblemIdFromQuery(): string | undefined {
  const hashQuery = window.location.hash.includes("?")
    ? window.location.hash.split("?")[1]
    : "";

  return (
    new URLSearchParams(
      hashQuery || window.location.search.replace(/^\?/, ""),
    ).get("problemId") ?? undefined
  );
}

const ProblemPage: React.FC = () => {
  const { problemId, solutionId } = useParams<{
    problemId: string;
    solutionId: string;
  }>();
  const effectiveProblemId = problemId ?? getProblemIdFromQuery();

  const [solsExpanded, setSolsExpanded] = useState(false);
  const [probExpanded, setProbExpanded] = useState(true);
  const [caseExpanded, setCaseExpanded] = useState(false);

  return (
    <PageLayout
      withFooter={false}
      limitedWidth={false}
    >
      <Problem
        problemId={effectiveProblemId}
        solutionId={solutionId}
        solsExpanded={solsExpanded}
        setSolsExpanded={setSolsExpanded}
        probExpanded={probExpanded}
        setProbExpanded={setProbExpanded}
        caseExpanded={caseExpanded}
        setCaseExpanded={setCaseExpanded}
      />
    </PageLayout>
  );
};

export default ProblemPage;
